import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AccountModel } from '../../../../domain/models/account.model';
import { EnrollmentType } from '../../../../domain/enums/enrollment-type.enum';
import {
  EnrollmentTypeIndicatorComponent
} from '../../../../common/enrollment-type-indicator/enrollment-type-indicator.component';

export interface SearchResultRow {
  account: AccountModel;
  id: number;
  fullName: string;
  email: string;
  enrollmentType: EnrollmentType | undefined;
  propertyCount: number;
}

export interface SearchResultsDialogData {
  query: string;
  rows: SearchResultRow[];
}

@Component({
  selector: 'app-search-results-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatRadioModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    EnrollmentTypeIndicatorComponent,
  ],
  templateUrl: './search-results-dialog.component.html',
  styleUrl: './search-results-dialog.component.css',
})
export class SearchResultsDialogComponent implements AfterViewInit {
  displayedColumns = ['select', 'id', 'fullName', 'email', 'accountType', 'properties'];
  dataSource: MatTableDataSource<SearchResultRow>;
  selected: SearchResultRow | undefined;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<SearchResultsDialogComponent, AccountModel>,
    @Inject(MAT_DIALOG_DATA) public data: SearchResultsDialogData,
  ) {
    this.dataSource = new MatTableDataSource<SearchResultRow>(data.rows);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  goBack(): void {
    this.dialogRef.close();
  }

  viewReturns(): void {
    if (this.selected) {
      this.dialogRef.close(this.selected.account);
    }
  }
}
